import axios from "axios";

import { IP } from "utils/Host";


export function skasujPrzerweGant(targetId,proces_nazwa_id,refreshGantAll) {



  axios.delete(IP + "API_0018_gant_skasuj_przerwe_gold/"+ sessionStorage.getItem("token"), { data: { targetId: targetId, oprawa:proces_nazwa_id } })
    .then((res) => {
   refreshGantAll()

    });





}


